import { render, staticRenderFns } from "./uploudFile.vue?vue&type=template&id=1aa8d6c0&scoped=true"
import script from "./uploudFile.vue?vue&type=script&lang=ts"
export * from "./uploudFile.vue?vue&type=script&lang=ts"
import style0 from "./uploudFile.vue?vue&type=style&index=0&id=1aa8d6c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa8d6c0",
  null
  
)

export default component.exports